import styles from "./switch-button.module.scss";

type SwitchSize = "sm" | "md" | "lg";

const SIZE_VARS: Record<SwitchSize, React.CSSProperties> = {
	sm: { "--sw-track-width": "2rem",    "--sw-track-height": "1.25rem",  "--sw-thumb-size": "0.75rem", "--sw-thumb-translate": "0.75rem" } as React.CSSProperties,
	md: { "--sw-track-width": "2.625rem", "--sw-track-height": "1.6875rem", "--sw-thumb-size": "1.125rem", "--sw-thumb-translate": "1rem"   } as React.CSSProperties,
	lg: { "--sw-track-width": "3.5rem",  "--sw-track-height": "2.125rem", "--sw-thumb-size": "1.5rem",  "--sw-thumb-translate": "1.5rem"  } as React.CSSProperties,
};

interface SwitchButtonProps {
	isActive: boolean;
	onChange: (value: boolean) => void;
	type?: "primary" | "secondary";
	size?: SwitchSize;
	activeColor?: string;
	isLoading?: boolean;
	disabled?: boolean;
}

export const SwitchButton = ({
	isActive,
	onChange,
	type = "secondary",
	size = "md",
	activeColor,
	isLoading = false,
	disabled = false,
}: SwitchButtonProps) => {
	const handleClick = (e: React.MouseEvent) => {
		e.stopPropagation();
		if (!isLoading && !disabled) {
			onChange(!isActive);
		}
	};

	const style: React.CSSProperties = {
		...SIZE_VARS[size],
		...(activeColor ? { "--sw-active-color": activeColor } as React.CSSProperties : {}),
	};

	return (
		<div
			role="switch"
			aria-checked={isActive}
			aria-disabled={disabled}
			onClick={handleClick}
			style={style}
			className={[
				styles.track,
				isActive ? styles.active : "",
				type === "primary" ? styles.primary : "",
				isLoading ? styles.loading : "",
				disabled ? styles.disabled : "",
			]
				.filter(Boolean)
				.join(" ")}
		>
			<span className={styles.thumb} />
		</div>
	);
};
